import Vue from 'vue';
import { NoticeBar } from 'vant';
import 'vant/lib/index.css';
import '@assets/scss/officialTopupNew/font/icon.js';
import '@assets/scss/officialTopupNew/font/iconfont.js';
if (window.hwerrVue) {
  Vue.config.errorHandler = window.hwerrVue;
}


import App from '../../officialTopupNewApp.vue';
import router from '../rooters/officialTopupNew';
import store from '../stores/officialTopupNew';
import commonComponents from '@components/officialTopupNew/common/commonComponents';
import clickThrottling from '../../resource/plugins/clickThrottling';
import 'swiper/css/swiper.css';
import { handleStoreDefaultCid } from '@utiles/storeHandleCid';
import '@plugins/replaceAllPolyfills';
import globalConfig from '@utiles/officialStore/globalConfig';
import bridge from '@utiles/bridge';
import { initFlowTrack } from '@utiles/officialTopupNew/flowTrack';
import { ensureV35PointFallback } from '@plugins/biPoint/ensureBiPoint';

// ！！！注意：重定向逻辑要在initBiPoint之前，否则会导致【会话开始】打点打在旧页面.
// 重定向逻辑 start
const gameId =
  globalConfig.getHrefParam('gameId') ||
  globalConfig.getHrefParam('gameID') ||
  globalConfig.getHrefParam('game_id') ||
  '';

// 311 游戏内带 gameBtnSdkId 时外跳浏览器并关闭 webview
if ([311].includes(+gameId) && bridge.runInsdk() && globalConfig.getHrefParam('cfriversdkbiz') == 'gameButton' && window?.location?.hash === '#/') {
  bridge.callSdkMethod('openBrowser', {
    url: window.location.href,
    loginDir: 1,
    appendParams: 0
  });
  setTimeout(() => {
    bridge.callSdkMethod('closeWebview');
  }, 1000);
}

// 2025.7.8 ROV跳转ROG V3第三方支付页
if ([371].includes(+gameId)) {
  const currentUrl = new URL(window.location);
  currentUrl.searchParams.set('gameId', 426);
  if (bridge.runInsdk()) {
    bridge.callSdkMethod('openWebView', {
      url: currentUrl.href,
      loginDir: 0,
      appendParams: 1,
      pageOrientation: 1
    });
  } else {
    window.location.href = currentUrl.href;
  }
}

// 脚本协议版本 >= 页面所需版本则跳过；否则由页面补监听
ensureV35PointFallback();
handleStoreDefaultCid();
initFlowTrack();
Vue.use(NoticeBar);

// 设置点击节流.
Vue.use(clickThrottling);
clickThrottling.setThrottlingTime(300);

Vue.config.productionTip = true;
Vue.use(commonComponents);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#officialTopupNew');
